import { useAxios } from "@/lib/hooks";

export const useFeedbackApi = () => {
  const { axiosInstance } = useAxios();

  const createFeedback = async ({
    description,
    pageUrl,
    category,
    attachments,
  }: {
    description: string;
    pageUrl: string;
    category: string;
    attachments: File[];
  }) => {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("page_url", pageUrl);
    formData.append("category", category);
    attachments.forEach((attachment) => {
      formData.append("attachments", attachment);
    });

    const response = await axiosInstance.post("/feedback", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return response.data;
  };

  return {
    createFeedback,
  };
};
